import React from 'react'
import { EloBaseIcon, EloBaseIconProps } from '../_base'

export const EloClockWaiting: React.FC<EloBaseIconProps> = (props) => (
  <EloBaseIcon {...props}>
    <circle cx='10' cy='10' r='7.5' stroke='currentColor' strokeWidth='1.5' />
    <path d='M10 6.25v4.375l2.5 1.25' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' />
  </EloBaseIcon>
)
